<div
	class="flex items-center justify-between gap-2 border rounded-xl p-4 bg-white"
>
	<div class="flex items-center gap-2">
		<atomic-name-badge
			[firstName]="invitee_()?.name?.split(' ')[0] || ''"
			[lastName]="invitee_()?.name?.split(' ').slice(1).join(' ') || ''"
			size="small"
		></atomic-name-badge>

		<div class="flex flex-col">
			<span [testHook]="testHooks.DisplayNameSpan">{{
				invitee_()?.displayName || invitee_()?.name
			}}</span>
			<div class="flex items-center gap-1">
				@if (!invitee_()?.email) {
					<i-tabler name="alert-triangle" class="text-red-500 w-4 h-4" />
					<span class="text-sm">Missing email</span>
					<button
						(click)="updateClientEmail()"
						class="text-sm text-green-600 hover:text-green-800 hover:underline font-medium"
						[testHook]="testHooks.UpdateButton"
					>
						Update
					</button>
				} @else {
					<span class="text-sm text-gray-500">{{ invitee_()?.email }}</span>
				}
			</div>
		</div>
	</div>

	<ui-dropdown [items]="kebabOptions_()">
		<ui-button
			dropdown-trigger
			preset="ICON_DEFAULT"
			icon="dots-vertical"
			size="sm"
		/>
	</ui-dropdown>
</div>
